module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast4#_idTextAnchor001"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast5#_idTextAnchor002"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast6#_idTextAnchor003"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast7#_idTextAnchor174"
    }
  }, [_vm._v("1. Creation of the World and of Humankind")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast8#_idTextAnchor337"
    }
  }, [_vm._v("2. The Entry of Sin into the World and Its Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast9#_idTextAnchor547"
    }
  }, [_vm._v("3. Parables of Female Godliness")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast10#_idTextAnchor737"
    }
  }, [_vm._v("4. Mary: Prophet of a New Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast11#_idTextAnchor1016"
    }
  }, [_vm._v("5. Women Healed and Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast12#_idTextAnchor1154"
    }
  }, [_vm._v("6. Deacon Phoebe and Other Women Ministers")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast13#_idTextAnchor1439"
    }
  }, [_vm._v("7. Mary Magdalene, Junia, and Other Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast14#_idTextAnchor1646"
    }
  }, [_vm._v("8. Pitting Mary against Martha: "), _c('br'), _vm._v("Conflicts over Women’s Roles")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast15#_idTextAnchor1832"
    }
  }, [_vm._v("9. From Death to New Life")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast16#_idTextAnchor1986"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast17#_idTextAnchor1987"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast18#_idTextAnchor1988"
    }
  }, [_c('em', [_vm._v("Subject and Name Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast19#_idTextAnchor1989"
    }
  }, [_c('em', [_vm._v("Scripture Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee07c62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reid_Wisdoms_Feast-3.vue
// module id = 63
// module chunks = 0